import { defineComponent as K, computed as v, ref as Q, createElementBlock as n, openBlock as d, createElementVNode as c, mergeProps as V, createCommentVNode as u, renderSlot as k, createTextVNode as x, toDisplayString as m, normalizeClass as i, createBlock as I, unref as r, withCtx as y, Fragment as C, renderList as T, createVNode as W, withDirectives as X, vShow as Y } from "vue";
import { RevButtonIcon as L } from "@ds/components/ButtonIcon";
import { RevCheckbox as O } from "@ds/components/Checkbox";
import j from "../CheckboxBase/CheckboxBase.vue2.js";
import { RevTooltip as Z } from "@ds/components/Tooltip";
import { usePropsValidation as _ } from "../../composables/usePropsValidation.js";
import ee from "../../icons/generated/IconChevronDown.vue2.js";
import te from "../../icons/generated/IconChevronUp.vue2.js";
import le from "../../icons/generated/IconInfo.vue2.js";
import { tw as a } from "../../utils/tailwind.js";
import ae from "./components/TableSortingHeader.vue2.js";
const de = {
  key: 0,
  class: "heading-2 m-24 text-left"
}, oe = { class: "block md:table-row" }, ne = {
  key: 0,
  class: "px-16 text-start first:pl-24",
  scope: "col"
}, se = ["id"], ce = { class: "flex items-center" }, ie = ["id"], re = ["headers"], ue = ["headers"], be = ["id", "aria-expanded"], fe = { colspan: "100" }, he = ["id", "aria-expanded"], me = { colspan: "100" }, Ne = /* @__PURE__ */ K({
  name: "RevTable",
  __name: "Table",
  props: {
    caption: { default: "" },
    checkedIds: { default: () => {
    } },
    selectAllLabel: { default: "Select All" },
    showCheckboxesLabels: { type: Boolean, default: !1 },
    collection: {},
    getCollectionItemId: { type: Function, default: (e) => typeof e == "object" && e !== null && "id" in e ? e.id : "" },
    columns: {},
    stripedRows: { type: Boolean, default: !1 },
    sortOptions: { default: null },
    transparentHeader: { type: Boolean, default: !1 },
    expandLabel: { default: "Expand" },
    expandRowsByDefault: { type: Boolean, default: !1 },
    shouldMountExpandedRows: { type: Boolean, default: !1 }
  },
  emits: ["update:sortOptions", "update:checkedIds", "update:expandAll", "update:expandedRow"],
  setup(e, { expose: D, emit: M }) {
    const b = M;
    _({
      "`selectAllLabel` should be provided if `checkedIds` was chosen": () => e.checkedIds && !e.selectAllLabel,
      "collection items should have an id property or a `getCollectionItemId` method should be provided if `checkedIds` or `expandable` rows are used": () => e.checkedIds || e.collection.some((l) => l.expandable) ? e.collection.some(
        (l) => e.getCollectionItemId(l) === void 0
      ) : !1
    });
    const g = v(() => ({
      align: "end",
      key: "expand",
      label: e.expandLabel
    })), w = v(() => e.collection.length === e.checkedIds?.length), S = v(() => [
      a`border-static-default-low body-1-bold h-56 border-b-1`,
      a`hidden`,
      a`md:table-row-group`,
      e.transparentHeader ? a`bg-transparent` : a`bg-static-default-hi`
    ]), $ = v(() => [
      a`bg-static-default-min`,
      a`mt-24 block`,
      a`md:border-static-default-low md:mt-0 md:table-row md:border-b-1 md:last:border-b-0`,
      e.stripedRows && a`md:even:bg-static-default-mid`
    ]), U = v(() => [
      a`px-16`,
      a`border-static-default-low flex items-center justify-between border-b-1 py-12 before:content-[attr(headers)] first:pl-24`,
      a`md:table-cell md:border-none md:py-24 md:before:content-none`,
      e.stripedRows && a`md:even:bg-static-default-mid`
    ]), F = (l) => [
      a`px-16 first:pl-24`,
      l.highlighted && a`bg-static-info-low`
    ], A = (l) => [
      a`group`,
      a`border-static-default-low border-b-1 md:border-none `,
      a`before:body-1-bold before:px-16 before:py-12 before:content-[attr(headers)] md:before:content-none`,
      a`flex items-center justify-between md:table-cell`,
      e.stripedRows && !l.highlighted && a`even:bg-static-default-mid md:even:before:bg-static-default-hi even:md:bg-transparent`,
      l.highlighted && a`bg-static-info-low`
    ], z = (l) => [
      a`mr-8 text-left`,
      l.headerClassNames
    ], p = (l) => [
      a`flex items-center px-16 py-12 text-end md:py-24 md:text-start md:group-first-of-type:pl-24 md:group-last-of-type:pr-24`,
      l.isTabular && a`justify-end tabular-nums`,
      !l.isTabular && !l.align && a`justify-start`,
      !l.isTabular && l.align === "start" && a`justify-start`,
      !l.isTabular && l.align === "center" && a`justify-center`,
      !l.isTabular && l.align === "end" && a`justify-end`
    ];
    function H(l) {
      return e.sortOptions?.sortBy === l && e.sortOptions?.sortOrder || "UNDEFINED";
    }
    function P(l, o) {
      b("update:sortOptions", { sortBy: l, sortOrder: o });
    }
    function N() {
      if (w.value)
        b("update:checkedIds", []);
      else {
        const l = e.collection.map(
          (o) => e.getCollectionItemId(o)
        );
        b("update:checkedIds", l);
      }
    }
    function B(l) {
      if (!e.checkedIds)
        return;
      const o = e.getCollectionItemId(l);
      e.checkedIds.includes(o) ? b(
        "update:checkedIds",
        e.checkedIds.filter((t) => t !== o)
      ) : b("update:checkedIds", [...e.checkedIds, o]);
    }
    function q() {
      return e.collection.filter((o) => o.expandable).reduce((o, t) => ({
        ...o,
        [e.getCollectionItemId(t)]: e.expandRowsByDefault
      }), {});
    }
    const f = Q(q()), R = v(() => e.collection.some((l) => l.expandable !== void 0));
    function G(l) {
      const o = !f.value[e.getCollectionItemId(l)];
      f.value[e.getCollectionItemId(l)] = o, b("update:expandedRow", e.getCollectionItemId(l), o);
    }
    const E = (l) => {
      const o = e.collection.filter((t) => t.expandable);
      o.length !== 0 && (f.value = o.reduce(
        (t, h) => ({
          ...t,
          [e.getCollectionItemId(h)]: l
        }),
        {}
      ));
    };
    return D({
      expandAll: () => {
        E(!0), b("update:expandAll", !0);
      },
      collapseAll: () => {
        E(!1), b("update:expandAll", !1);
      }
    }), (l, o) => (d(), n("div", null, [
      c("table", V({
        ...R.value && { "aria-live": "polite" }
      }, { class: "text-static-default-mid body-1 w-full border-collapse border-spacing-0 border-0" }), [
        e.caption ? (d(), n("caption", de, [
          k(l.$slots, "caption", { caption: e.caption }, () => [
            x(m(e.caption), 1)
          ])
        ])) : u("", !0),
        c("thead", {
          class: i(S.value)
        }, [
          c("tr", oe, [
            e.checkedIds ? (d(), n("th", ne, [
              e.showCheckboxesLabels ? (d(), I(r(O), {
                key: 1,
                id: "table-select-all",
                "model-value": w.value,
                value: "select-all",
                "onUpdate:modelValue": N
              }, {
                label: y(() => [
                  x(m(e.selectAllLabel), 1)
                ]),
                _: 1
              }, 8, ["model-value"])) : (d(), I(r(j), {
                key: 0,
                id: "table-select-all",
                label: e.selectAllLabel,
                "model-value": w.value,
                value: "select-all",
                "onUpdate:modelValue": N
              }, null, 8, ["label", "model-value"]))
            ])) : u("", !0),
            (d(!0), n(C, null, T(e.columns, (t) => (d(), n("th", {
              id: t.label,
              key: t.key,
              class: i(F(t)),
              scope: "col"
            }, [
              c("div", ce, [
                c("span", {
                  class: i(z(t))
                }, m(t.label), 3),
                t.isSortable ? (d(), I(ae, {
                  key: 0,
                  value: H(t.key),
                  onChange: (h) => P(t.key, h)
                }, null, 8, ["value", "onChange"])) : u("", !0),
                t.description ? (d(), I(r(Z), {
                  key: 1,
                  class: "ml-2"
                }, {
                  trigger: y(({ show: h, hide: s, ...J }) => [
                    W(r(L), V({ icon: r(le) }, { ref_for: !0 }, J, {
                      size: "small",
                      variant: "secondary",
                      onBlur: s,
                      onFocusin: h,
                      onMouseleave: s,
                      onMouseover: h
                    }), null, 16, ["icon", "onBlur", "onFocusin", "onMouseleave", "onMouseover"])
                  ]),
                  default: y(() => [
                    x(" " + m(t.description), 1)
                  ]),
                  _: 2
                }, 1024)) : u("", !0)
              ])
            ], 10, se))), 128)),
            R.value ? (d(), n("th", {
              key: 1,
              id: g.value.label,
              class: "px-16 text-end",
              scope: "col"
            }, m(g.value.label), 9, ie)) : u("", !0)
          ])
        ], 2),
        c("tbody", null, [
          (d(!0), n(C, null, T(e.collection, (t, h) => (d(), n(C, {
            key: e.getCollectionItemId(t)
          }, [
            c("tr", {
              class: i($.value),
              scope: "row"
            }, [
              e.checkedIds ? (d(), n("td", {
                key: 0,
                class: i(U.value),
                headers: ""
              }, [
                e.showCheckboxesLabels ? (d(), I(r(O), {
                  key: 1,
                  id: `checkbox-${e.getCollectionItemId(t)}`,
                  "model-value": e.checkedIds.includes(e.getCollectionItemId(t)),
                  value: `checkbox-${e.getCollectionItemId(t)}`,
                  "onUpdate:modelValue": (s) => B(t)
                }, {
                  label: y(() => [
                    x(m(
                      // Fallback hardcoded value for backward compatibility
                      t.rowCheckboxLabel || "Select One"
                    ), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "model-value", "value", "onUpdate:modelValue"])) : (d(), I(r(j), {
                  key: 0,
                  id: `checkbox-${e.getCollectionItemId(t)}`,
                  label: t.rowCheckboxLabel || `${t?.title || e.columns[0]?.label || h}-${e.getCollectionItemId(t)}`,
                  "model-value": e.checkedIds.includes(e.getCollectionItemId(t)),
                  value: `checkbox-${e.getCollectionItemId(t)}`,
                  "onUpdate:modelValue": (s) => B(t)
                }, null, 8, ["id", "label", "model-value", "value", "onUpdate:modelValue"]))
              ], 2)) : u("", !0),
              (d(!0), n(C, null, T(e.columns, (s) => (d(), n("td", {
                key: s.key,
                class: i(A(s)),
                headers: s.label
              }, [
                c("div", {
                  class: i(p(s))
                }, [
                  k(l.$slots, `body-${s.key}`, {
                    column: s,
                    item: t
                  }, () => [
                    x(m(t?.[s.key]), 1)
                  ])
                ], 2)
              ], 10, re))), 128)),
              R.value ? (d(), n("td", {
                key: 1,
                class: i(A(g.value)),
                headers: g.value.label
              }, [
                c("div", {
                  class: i(p(g.value))
                }, [
                  t.expandable ? (d(), I(r(L), {
                    key: 0,
                    "alternative-text": g.value.label,
                    "aria-controls": `expand-${e.getCollectionItemId(t)}`,
                    icon: f.value[e.getCollectionItemId(t)] ? r(te) : r(ee),
                    size: "small",
                    variant: "secondary",
                    onClick: (s) => G(t)
                  }, null, 8, ["alternative-text", "aria-controls", "icon", "onClick"])) : u("", !0)
                ], 2)
              ], 10, ue)) : u("", !0)
            ], 2),
            !e.shouldMountExpandedRows && f.value[e.getCollectionItemId(t)] ? (d(), n("tr", {
              key: 0,
              id: `expand-${e.getCollectionItemId(t)}`,
              "aria-expanded": f.value[e.getCollectionItemId(t)],
              class: i($.value)
            }, [
              c("td", fe, [
                k(l.$slots, `expand-${e.getCollectionItemId(t)}`, { item: t })
              ])
            ], 10, be)) : e.shouldMountExpandedRows ? X((d(), n("tr", {
              key: 1,
              id: `expand-${e.getCollectionItemId(t)}`,
              "aria-expanded": f.value[e.getCollectionItemId(t)],
              class: i($.value)
            }, [
              c("td", me, [
                k(l.$slots, `expand-${e.getCollectionItemId(t)}`, { item: t })
              ])
            ], 10, he)), [
              [
                Y,
                e.shouldMountExpandedRows && f.value[e.getCollectionItemId(t)]
              ]
            ]) : u("", !0)
          ], 64))), 128))
        ])
      ], 16)
    ]));
  }
});
export {
  Ne as default
};
